import React, { Component } from 'react';
import './Dropdown.scss';
import DropdownMenu from '@/Common/DropdownMenu/DropdownMenu';
import Checkbox from "@/Common/Checkbox/Checkbox";
import i18n from '../../../i18n';
class Dropdown extends Component {
    lengthCategory = [
        { label: i18n.t("categoryfiltering.lengthcategory.10"), key: "10초 이하" },
        { label: i18n.t("categoryfiltering.lengthcategory.20"), key: "20초 이하" },
        { label: i18n.t("categoryfiltering.lengthcategory.30"), key: "30초 이하" },
        { label: i18n.t("categoryfiltering.lengthcategory.40"), key: "40초 이하" },
      ]
    dropdownMenus = [
        { categoryName: "lengthCategory", menuTitle: i18n.t("categoryfiltering.lengthcategory.menutitle.pc"), mobileMenuTitle: i18n.t("categoryfiltering.lengthcategory.menutitle.mobile"), lengthCategory : this.lengthCategory, arrow: "▼" },
    ];
    render() {
        const { onCheckboxChanged, categories } = this.props;
        return (
            <>
                {this.dropdownMenus.map((menuItem, index) => {
                    const { menuTitle, categoryName, arrow } = menuItem;
                    return (
                        <div key={index}>
                            <DropdownMenu
                                value={this.props.value}
                                menuTitle={menuTitle}
                                arrow={arrow}
                                categoryName={categoryName}
                                content={
                                    <Checkbox
                                        categoryName={categoryName}
                                        items={menuItem[categoryName]}
                                        checkboxState={categories[categoryName]}
                                        onCheckboxChanged={onCheckboxChanged}
                                    />
                                }
                            />
                        </div>
                    );
                })}
            </>
        );
    }
}

export default Dropdown;